import React from 'react';

const NebulaManagementFeeFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaManagementFeeModalRegistry = {
    personalize_nebulaManagementFeeId: NebulaManagementFeeFormModal
};
export default nebulaManagementFeeModalRegistry;
